// Which refusal the boot panel is rendering. Kept here, next to the API client
// that produces the code, rather than inside the panel: it is pure logic on the
// wire contract, and both App and the area boundary map onto it.
//
// The backend names the refusal in the 403 detail's `error`
// (`backend/web/deps/identity.py::require_employee`) because status alone cannot
// say whether an operator can DO anything about it.

/** The three states the sign-in panel renders. */
export type SignInReason = "signed-out" | "wrong-identity" | "not-employee";

/**
 * Map a boot failure onto the panel state.
 *
 * An unknown 403 reads as `wrong-identity`, deliberately: that state offers
 * strictly MORE ways out than `not-employee`, so a code this bundle predates
 * (an older backend, a refusal added later) can never dead-end an operator. The
 * panel used to do the opposite, treating every 403 as "not an authorized
 * employee" with no sign-in button, which is how a client cookie on the shared
 * dev/preprod cookie domain locked the team out of the console.
 */
export function resolveSignInReason(status: number | "network", code: string | null): SignInReason {
  if (status === 401) return "signed-out";
  if (code === "not_employee") return "not-employee";
  return "wrong-identity";
}
